import type { NodeDefault } from '../../types';
import { BlockEnum } from '../../types';
import {
  // ALL_CHAT_AVAILABLE_BLOCKS,
  ALL_COMPLETION_AVAILABLE_BLOCKS,
} from '../../blocks';
import type { MirrorNodeType } from './types';

const nodeDefault: NodeDefault<MirrorNodeType> = {
  defaultValue: {
    hash: 1,
    bgColor: 'bg-util-colors-blue-blue-500'
  },
  getAvailablePrevNodes() {
    return ALL_COMPLETION_AVAILABLE_BLOCKS.filter(
      (type) => (type !== BlockEnum.End && type !== BlockEnum.Start && type !== BlockEnum.Mirror),
    );
  },
  getAvailableNextNodes(isChatMode: boolean = false) {
    return [];
  },
  checkValid() {
    return {
      isValid: true,
    };
  },
};

export default nodeDefault;
